/* eslint-disable @typescript-eslint/indent */
import React, { ReactNode } from 'react';
import SwiperCore, { Navigation, Lazy } from 'swiper';
import { Swiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/lazy';

type NavigationType = {
  prevRef: React.RefObject<HTMLDivElement>;
  nextRef: React.RefObject<HTMLDivElement>;
};

type PopularLocationsSwiperProps = {
  children: ReactNode;
  navigation: NavigationType;
  spaceBetween?: number;
  isPaginated?: boolean;
  isShortSwipesEnabled?: boolean;
  loop?: boolean;
};

const defaultProps = {
  spaceBetween: 14,
  isPaginated: false,
  isShortSwipesEnabled: true,
  loop: true,
};

SwiperCore.use([Navigation, Lazy]);

export default function PopularLocationsSwiper({
  children,
  navigation,
  spaceBetween,
  isPaginated,
  isShortSwipesEnabled = true,
  loop = true,
}: PopularLocationsSwiperProps) {
  return (
    <Swiper
      spaceBetween={spaceBetween ?? 14}
      slidesPerView="auto"
      loop={loop}
      navigation={{
        prevEl: navigation.prevRef.current!,
        nextEl: navigation.nextRef.current!,
      }}
      preloadImages={false}
      lazy={{
        loadPrevNext: false,
      }}
      pagination={
        isPaginated
          ? {
              dynamicBullets: true,
              dynamicMainBullets: 3,
            }
          : false
      }
      onBeforeInit={(swiper: SwiperCore): void => {
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        swiper.params.navigation.prevEl = navigation.prevRef.current;
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        swiper.params.navigation.nextEl = navigation.nextRef.current;
      }}
      breakpoints={{
        // when window width is >= 850px
        850: {
          shortSwipes: isShortSwipesEnabled,
        },
      }}
    >
      {children}
    </Swiper>
  );
}

PopularLocationsSwiper.defaultProps = defaultProps;
